export const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY

export const loadRecaptchaScript = () => {
  if (process.env.NODE_ENV !== 'production') return

  const script = document.createElement("script")
  script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`
  script.async = true

  script.onload = () => {
    console.log("reCAPTCHA script loaded successfully!")
  }

  script.onerror = (err) => {
    console.error("Error loading reCAPTCHA script:", err)
  }

  document.body.appendChild(script)
}

export const executeRecaptcha = async () => {
  if (process.env.NODE_ENV !== 'production') return null

  try {
    const token = await window.grecaptcha.execute(recaptchaSiteKey, {
      action: "login",
    })
    return token
  } catch (error) {
    console.error("Error executing reCAPTCHA", error)
  }

  return null
}
